export const validPostalCodeNetherlands = (v) => /^\d{4}\s?\w{2}$/.test(v)
export const validTelephone = (v) => ['+', '0'].includes(v[0]) && v.length > 8
export const boxIsChecked = (v) => v === true